<template>
    <v-row no-gutters align="center" justify="center" class="fill-height">
        <v-col cols="10" align="center" class="mt-4">
            <v-card :width="width" :height="height">
                <v-card-title class="d-flex align-center justify-center">AI Tester - Tourist
                    <v-spacer></v-spacer>
                    <v-btn color="error" outlined @click="clearChat()">Clear Chat</v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card flat :height="height - 125">
                    <v-card-text>
                        <v-row no-gutters align="end" justify="end">
                            <v-col cols="3">
                                <v-select v-model="selectedLocation" outlined label="Selected Location" class="mx-2"
                                    dense :items="locations" item-text="name" item-value="code"></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-select v-model="selectedLanguage" outlined label="Select Language" class="mx-2" dense
                                    :items="languages" item-text="name" item-value="code"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text id="msg-container" v-if="aiConversation.length > 0">
                        <v-card id="chatContainer" :height="height - 245" class="overflow-y-auto" flat>
                            <div v-for="(msg, index) in aiConversation" :key="index" class="pa-0 ma-2">
                                <v-container :class="msg.isMe ? 'd-flex justify-end' : 'd-flex justify-start'"
                                    class="pa-0 ma-0">
                                    <v-card class="py-1 px-2 ml-2 white--text text-subtitle-1 text-left" rounded="lg"
                                        :color="msg.isMe ? 'primary' : 'secondary'" max-width="60%" min-width="25%">
                                        <span v-html="msg.message"></span>
                                        <div v-if="!msg.isMe">
                                            <br>
                                            <span>Action: {{ msg.intent }}</span>
                                            <br>
                                            <span v-if="msg.intentname === 'showCategory'">Category Name: {{
                                                msg.categoryName }}</span>
                                            <span v-if="msg.intentname === 'showDialog'">Dialog Name: {{ msg.dialogName
                                            }}</span>
                                            <span v-if="msg.intentname === 'showImage'">Image Name: {{ msg.imageName
                                            }}</span>
                                            <span v-if="msg.intentname === 'showItem'">Item Name: {{ msg.itemName
                                            }}</span>
                                            <span v-if="msg.intentname === 'showUrl'">Url Name: {{ msg.urlName
                                            }}</span>
                                        </div>
                                    </v-card>
                                </v-container>
                                <span v-if="msg.isMe" class="d-flex justify-end pr-2 ml-10 text-caption">You {{ msg.date
                                }}</span>
                                <span v-else class="d-flex justify-start pl-2 text-caption">Tracey {{ msg.date }}</span>
                            </div>

                            <v-container class="d-flex justify-start pa-0 ma-0" v-if="isThinking">
                                <v-card width="150" height="45"
                                    class="d-flex align-center justify-center white--text text-subtitle-1 ml-4"
                                    color="secondary" rounded="lg">
                                    <div id="thinking-text">{{ thinkingText }}</div>
                                </v-card>
                            </v-container>
                        </v-card>
                    </v-card-text>
                    <v-card-text class="d-flex align-center justify-center" v-else>
                        <v-row no-gutters>
                            <!-- <v-col cols="12" class="d-flex align-center justify-center">
                                <v-img src="@/assets/customer-service.png" max-width="150" contain></v-img>
                            </v-col> -->
                            <v-col cols="12" class="d-flex align-center justify-center mt-5">
                                <span class="black--text font-weight-bold justify-center">
                                    Hi, I'm Tracey, <br> I can assist you with questions related to El Paso Tourism.
                                </span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-divider></v-divider>
                <v-card-text>
                    <v-text-field v-if="!pastConversation" dense label="Ask El Paso tourism related question"
                        v-model="question" append-outer-icon="mdi-send" @click:append-outer="sendMessage"
                        @keyup.enter="sendMessage"></v-text-field>
                    <v-text-field v-else dense label="Click on 'Clear Chat' top right to start a new conversation"
                        v-model="question" append-outer-icon="mdi-send" @click:append-outer="sendMessage"
                        @keyup.enter="sendMessage" disabled></v-text-field>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="2">
            <v-card :height="height + 80" width="100%" class="mx-2">
                <v-card-title>Chat History</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-list :height="height - 20" class="overflow-y-auto">
                        <template v-for="(conversation, index) in getPastConversations">
                            <v-list-item :key="index" @click="loadConversation(conversation)">
                                <v-list-item-content>
                                    <v-list-item-title> {{ conversation.sessionId }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider :key="index + 100"></v-divider>
                        </template>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
const axios = require('axios');
import moment from 'moment';
import { mapGetters } from 'vuex';
import crypto from "crypto"
export default {
    name: 'aiTesterTourist',
    data() {
        return {
            width: window.innerWidth - 1000,
            height: window.innerHeight - 150,
            question: '',
            conversation: [],
            languages: [
                { name: 'English', code: 'en' },
                { name: 'Español', code: 'es-US' },
            ],
            locations: [
                { name: 'El Paso Zoo', code: 'epz' },
                { name: 'Los Portales Museum', code: 'eplpm' },
            ],
            selectedLanguage: 'en',
            selectedLocation: 'epz',
            isThinking: false,
            dotCount: 0,
            thinkingText: "Thinking",
            interval: null,
            pastConversation: false,
        }
    },
    watch: {
        aiConversation() {
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        }
    },
    computed: {
        ...mapGetters(['aiConversation', 'getPastConversations'])
    },
    methods: {
        clearChat() {
            this.$store.commit('clearConversation')
            this.pastConversation = false
        },
        changeLanguage(code) {
            this.selectedLanguage = code
        },
        sendMessage() {
            if (this.aiConversation.length === 0) {
                this.$store.commit('setConversationSession', crypto.randomBytes(50).toString("hex").slice(0, 15))
            }
            this.$store.commit('setConversation', { isMe: true, message: this.question, date: moment().format('LTS') });
            this.$store.dispatch('saveConversationToStrapi', { isMe: true, message: this.question, date: moment().format('LTS') })
            this.callAI(this.question);
            this.question = '';
        },
        loadConversation(conObj) {
            this.pastConversation = true
            console.log('Past Conversation: ', conObj)
            this.$store.commit('clearConversation');
            conObj.conversation.forEach(conv => {
                this.$store.commit('setConversation', conv);
            })
        },
        callAI(question) {
            this.isThinking = true
            let data;
            if (this.selectedLanguage === 'en') {
                data = JSON.stringify({
                    "question": question,
                    "type": this.selectedLocation,
                    "lang": "english",
                    "client": "eptourist"
                });
            } else {
                data = JSON.stringify({
                    "question": question,
                    "type": this.selectedLocation,
                    "lang": "spanish",
                    "client": "eptourist"
                });
            }

            console.log('Request data to AI: ', data)

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios.request(config)
                .then((response) => {
                    console.log('Response from AI: ', response.data.answer);
                    if (response.data.answer.intent === '0' || response.data.answer.intent === 0) {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'showCategory', intent: 'Specific Category will be displayed on the kiosk', categoryName: response.data.answer.metadata.categoryName, date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'showCategory', intent: 'Map will be displayed on the kiosk', categoryName: response.data.answer.metadata.categoryName, date: moment().format('LTS') })
                    } else if (response.data.answer.intent === '1' || response.data.answer.intent === 1) {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'showImage', intent: 'Image will be displayed on kiosk', imageName: response.data.answer.metadata.imageName, date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'searchbylinkid', intent: 'Image will be displayed on kiosk', imageName: response.data.answer.metadata.imageName, date: moment().format('LTS') })
                    } else if (response.data.answer.intent === '2' || response.data.answer.intent === 2) {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'showItem', intent: 'Specific location will be displayed on the kiosk', itemName: response.data.answer.metadata.itemName, date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'showItem', intent: 'Specific location will be displayed on the kiosk', itemName: response.data.answer.metadata.itemName, date: moment().format('LTS') })
                    } else if (response.data.answer.intent === '3' || response.data.answer.intent === 3) {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'showUrl', intent: 'The application will be redirected to the url', urlTo: response.data.answer.metadata.urlName, date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'showUrl', intent: 'The application will be redirected to the url', urlTo: response.data.answer.metadata.urlName, date: moment().format('LTS') })
                    } else if (response.data.answer.intent === '4' || response.data.answer.intent === 4) {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'showDialog', intent: 'A dialog with multiple categories will be displayed', dialogName: response.data.answer.metadata.dialogName, date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'showDialog', intent: 'A dialog with multiple categories will be displayed', dialogName: response.data.answer.metadata.dialogName, date: moment().format('LTS') })
                    } else if (response.data.answer.intent === '5' || response.data.answer.intent === 5) {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'speak', intent: 'Response will be displayed on the kiosk', date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'speak', intent: 'Response will be displayed on the kiosk', date: moment().format('LTS') })
                    }
                    else if (response.data.answer.intent === 'fallback') {
                        // fallback
                        this.$store.commit('setConversation', { isMe: false, message: 'Sorry. I don`t have answer', intentname: 'speak', intent: 'Not found', date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: 'Sorry. I don`t have answer', intentname: 'speak', intent: 'Not found', date: moment().format('LTS') })
                    }
                    else {
                        this.$store.commit('setConversation', { isMe: false, message: 'Something went wrong. Please try again with a different question.', intentname: 'speak', intent: 'Error', date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: 'Something went wrong. Please try again with a different question.', intentname: 'speak', intent: 'Error', date: moment().format('LTS') })
                    }
                    this.isThinking = false
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        scrollToBottom() {
            const container = document.getElementById('chatContainer');
            if (container) {
                console.log('Coming inside after container found: ', container)
                container.scrollTop = container.scrollHeight;
            }
        }
    },

    mounted() {
        this.scrollToBottom();
        this.interval = setInterval(() => {
            this.dotCount = (this.dotCount + 1) % 4;
            this.thinkingText = 'Thinking' + '.'.repeat(this.dotCount);
        }, 500); // Adjust the interval as needed
        this.$store.dispatch('pullPastConversations')
        this.$store.commit('clearConversation')
    },
    beforeDestroy() {
        clearInterval(this.interval);
    }
}
</script>
<style>
.chatCard {
    border-width: 1px;
    border-style: solid;
    border-color: grey !important;
    border-radius: 15px !important;
}

.scrollable-content {
    overflow-y: auto;
    max-height: calc(100%)
}
</style>